import { render, staticRenderFns } from "./createOrganization.vue?vue&type=template&id=4e268fbc&scoped=true&"
import script from "./createOrganization.vue?vue&type=script&lang=js&"
export * from "./createOrganization.vue?vue&type=script&lang=js&"
import style0 from "./createOrganization.vue?vue&type=style&index=0&id=4e268fbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e268fbc",
  null
  
)

export default component.exports